<template>
	<div id="loginroles">
		<div class="row">
			<div class="col-12">
				<el-select v-model="LoginRoleID" placeholder="Select" class="topDropdown mb-4" @change="getLoginRoleData()" default-first-option filterable>
					<el-option v-if="createAccess" key="" label="-- Add New --" value=""></el-option>
					<el-option
					  v-for="item in LoginRole"
					  :label="item.RoleName"
					  :value="item.LoginRoleID"
					  :key="item.LoginRoleID">
					</el-option>
				</el-select>
            </div>
        </div>
        <div class="row">
	        <div class="col-12 card" style="padding:0;">
				<div class="card-header bg-primary" style="margin:0;"><h5>Login Role Access</h5></div>
				<div class="card-body">
					<el-form ref="loginRoleForm" label-position="top" :model="loginrole" label-width="120px" @submit.native.prevent>
						<div class="row form-group col-12" style="margin-bottom: 0;">
                            <el-form-item
                                label="Login Role Name"
                                prop="RoleName"
                                :rules="[
                                    { required: true, message: 'Login Role Name is required', trigger: 'blur'}

                                ]"
                            >
                                <el-input v-model="loginrole.RoleName">
                                </el-input>
                            </el-form-item>
	                    </div>
						<div class="row form-group col-12">
							<el-form-item
									label="What User Type will use this Role?"
									prop="UserArea"
									:rules="[
                                    { required: true, message: 'User Type is required', trigger: 'blur'}

                                ]"
							>
								<el-radio-group size="default" v-model="loginrole.UserArea">
									<el-radio-button value="a">Administrators</el-radio-button>
									<el-radio-button value="p">Client Contacts</el-radio-button>
								</el-radio-group>
							</el-form-item>
						</div>
						<div class="row form-group col-6">
                            <el-form-item
                                label="Security Level (Higher = more Privileges)"
                                prop="gid"
                                :rules="[
                                    { required: true, message: 'Security Level is required', trigger: 'blur'}

                                ]"
                            >
                                <el-input type="number" v-model="loginrole.gid">
                                </el-input>
                            </el-form-item>
	                    </div>
						<div class="row form-group security-area-header">
							<div class="col-4">
								Security Area
							</div>
							<div class="col-4">
							    Access Rights
							</div>
							<div class="col-4">
							    Data Restrictions
							</div>
						</div>
						<div v-for="area in RoleSecurity" class="row form-group security-areas">
							<input type="hidden" id="SecurityAreaID" v-model="area.SecurityAreaID" />
							<div class="col-4 area-name">
								{{area.SecurityAreaName}}
							</div>
							<div v-if="area.SecurityAreaRestrictionType == 'RCM'" class="col-4 security-access">
								<div>
									<el-checkbox v-model="area.Params.ReadAccess">Read</el-checkbox>
		                        </div>
		                        <div>
		                            <el-checkbox v-model="area.Params.CreateAccess">Create</el-checkbox>
		                        </div>
		                        <div>
		                            <el-checkbox v-model="area.Params.ModifyAccess">Modify</el-checkbox>
	                            </div>
							</div>
							<div v-else class="col-4 security-access">
								<div>
									<el-radio v-model="area.Params.Access" value="true">Yes</el-radio>
								</div>
								<div>
									<el-radio v-model="area.Params.Access" value="false">No</el-radio>
								</div>
							</div>
							<div class="col-4 data-access">
								<div v-if="area.SecurityAreaData == 'y'" >
		                            <el-checkbox v-model="area.Params.OrganizationIDAccess">Client</el-checkbox>
		                        </div>
		                    </div>
						</div>
					</el-form>
				</div>
			</div>
        </div>
		<div class="row" v-if="(modifyAccess || (createAccess && LoginRoleID))" >
            <div class="col-12 text-center">
                <button class="btn btn-success btn-icon" @click="saveLoginRole" style="margin-right: 10px;">
                    <i class="fas fa-check"></i> <span>Save Changes</span>
                </button>
                <button v-if="LoginRoleID" class="btn btn-success btn-icon" @click="saveNewLoginRole" style="margin-right: 10px;">
                    <i class="fas fa-check"></i> <span> Save As New</span>
                </button>
                <button v-if="LoginRoleID" class="btn btn-icon btn-danger delete"  @click="cnfmDeleteLoginRole()" style="margin-right: 10px;">
                    <i class="fas fa-trash"></i>  <span>Delete</span>
                </button>
                <button class="btn btn-icon btn-dark cancel"  @click="reset(true)">
                    <i class="fas fa-times"></i>  <span>Cancel</span>
                </button>
            </div>
        </div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';
    import Util from "@/assets/js/util";

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
	export default {
		data () {
			return {
				currentStatus: null,
				LoginRoleID: null,
				loginrole: {
					LoginRoleID: '',
					RoleName: ''
				},
				LoginRole: [],
				RoleSecurity: [],
			}
		},
		name: 'LoginRole',
		computed: {
			...mapGetters({ currentUser: 'currentUser' }),
			...mapGetters({ componentIDs: 'componentIDs' }),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
            createAccess () {
                return Util.createAccess(this.currentUser);
            },
            modifyAccess () {
                return Util.modifyAccess(this.currentUser);
            },
		},
		methods: {
			reset(showMessage) {
				if (showMessage) {
					this.$root.$emit('refreshData');
				} else {
					// reset form to initial state
					this.currentStatus = STATUS_INITIAL;
					if (showMessage) {
						this.getLoginRoleData();
						this.$notify({
							title: 'Success',
							message: "Login Role has been reset",
							type: 'success',
							duration: 1500,
							showClose: false
						});
	                 }
	            }
			},
			getInitialData () {
				let self = this;
				axios.post('/loginroles/getall',
				)
                .then(response => {
                    if (response.data.result == 'success') {
	                    this.LoginRole = response.data.LoginRole;
                        if (!this.LoginRoleID) {
                        	if (this.componentIDs.LoginRoleID) {
		                        this.LoginRoleID = this.componentIDs.LoginRoleID;
	                        } else {
		                        this.LoginRoleID = this.LoginRole[0].LoginRoleID;
	                        }
                        }
                        this.getLoginRoleData();
                    } else {
                    }
                }).catch(response => {
                });
			},
			getLoginRoleData () {
				this.RoleSecurity = [];
				let self = this;
				axios.post('/loginroles/get', {'LoginRoleID': this.LoginRoleID },
				)
                .then(response => {
                    if (response.data.result == 'success') {
	                    self.$store.dispatch('setID', {'LoginRoleID': self.LoginRoleID});
						this.RoleSecurity = response.data.RoleSecurity;
						if (response.data.LoginRole) {
							this.loginrole = response.data.LoginRole;
							this.LoginRoleID = this.loginrole.LoginRoleID;
						} else {
							this.loginrole = { LoginRoleID: '', RoleName: ''};
							this.LoginRoleID = '';
                        }
                    } else {
                    }
                }).catch(response => {

                });
			},
			saveLoginRole () {
	            this.$refs['loginRoleForm'].validate((valid) => {
                    if (valid) {
	                    if (!this.isDuplicate()) {
							if (this.currentStatus == STATUS_SAVING) {
								return true;
							}
							this.currentStatus = STATUS_SAVING;

							axios.post('/loginroles/save', {'LoginRole': this.loginrole, 'RoleSecurity': this.RoleSecurity}
							)
							.then(response => {
								if (response.data.result == 'success') {
									this.currentStatus = STATUS_INITIAL;
									if (!this.LoginRoleID) {
										this.LoginRole.push({LoginRoleID : response.data.LoginRoleID, RoleName : this.loginrole.RoleName});
										this.LoginRoleID = response.data.LoginRoleID;
										this.loginrole.LoginRoleID = response.data.LoginRoleID;
									}
									this.$notify({
										title: 'Success',
										message: "Login Role has been saved",
										type: 'success',
										duration: 1500,
										showClose: false
									});
								} else {
									this.currentStatus = STATUS_FAILED;
									this.displayPopup (response.data.message);
								}
							}).catch(response => {
								this.currentStatus = STATUS_FAILED;
							});
						} else {
							this.displayPopup ('This Role Name Already Exists.');
						}
					} else {
						//scroll to errors
		                let self = this;
	                    setTimeout(() => { var element = document.querySelector(".is-error"); self.$scrollTo(element); }, 250);
	                }
				});
			},
			saveNewLoginRole () {
				this.loginrole.LoginRoleID = 0;
				this.saveLoginRole ();
			},
            isDuplicate () {
                for (let i = 0; i < this.LoginRole.length; i++) {
                    if (this.LoginRole[i].LoginRoleID != this.loginrole.LoginRoleID && this.LoginRole[i].RoleName.toLowerCase() == this.loginrole.RoleName.toLowerCase().trim()) {
                        return true;
                    }
                }
                return false;
            },
			cnfmDeleteLoginRole() {
				this.$confirm('This will permanently delete this Login Role. Continue?', 'Warning', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					this.deleteLoginRole();
				}).catch(() => {
				});
			},
			deleteLoginRole () {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
				this.currentStatus = STATUS_SAVING;

				axios.post('/loginroles/delete', {'LoginRoleID': this.LoginRoleID}
				)
				.then(response => {
					if (response.data.result == 'success') {
						this.currentStatus = STATUS_INITIAL;

						this.$notify({
							title: 'Success',
							message: "Login Role has been deleted",
							type: 'success',
							duration: 1500,
							showClose: false
						});
		                this.LoginRoleID = '';
		                this.getInitialData();
					} else {
						this.currentStatus = STATUS_FAILED;
						this.displayPopup (response.data.message);
					}
				}).catch(response => {
					this.currentStatus = STATUS_FAILED;
				});
			},
	        displayPopup (message) {
				this.$alert(message, 'Login Role Error', {
					confirmButtonText: 'OK',
				});
	        }
		},
		mounted() {
			this.reset(false);
			this.getInitialData();
		},
	}
</script>


<style scoped>
	.card {
		padding-top: 0px;
		padding-bottom: 0px;
	}
	.card-header {
		margin: 20px -16px 20px -16px;
	}
	.footer {
	    width: 100%;
	    margin: 10px 0px;
	}
	.form-control:disabled.not-available {
		border : 0px;
		background: #fff;
		-webkit-appearance: none;
		margin: 0px 0px 0px -11px;
	}
	.security-area-header {
		border: 1px solid #ced4da;
		margin-bottom: 0;
		padding: 15px;
		background-color: #ced4da;
		font-weight: 800;
	}
	.security-areas {
		border: 1px solid #ced4da;
		border-top: 0;
		margin-bottom: 0;
	}
	.security-access {
		border-right: 1px solid #ced4da;
	}
	.area-name {
		font-weight: 600;
		border-right: 1px solid #ced4da;
		padding: 15px;
		vertical-align: middle;
	}
	.security-access {
		padding-left: 15px;
	}
	label {
		margin-bottom: 0;
	}
</style>
